import React from 'react';
import { Dialog, DialogContent, DialogTrigger } from './ui/dialog';
import ReservationForm from './ReservationForm';

const ReservationDialog = ({ trigger }) => {
  return (
    <Dialog>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="sm:max-w-[560px] p-0 border-0 bg-transparent shadow-none">
        <ReservationForm compact />
      </DialogContent>
    </Dialog>
  );
};

export default ReservationDialog;
